/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  function showToast(message, type) {
    if (window.Toastify) {
      window.Toastify({
        text: message,
        duration: 3000,
        close: true,
        gravity: 'top',
        position: 'right',
        style: {
          backgroundColor: type === 'error' ? '#FF0000' : '#009AD6',
        },
      }).showToast();
    }
  }

  function getSectionsToRender() {
    var mainCartEl = document.getElementById('main-cart-items');
    var sectionId = mainCartEl ? mainCartEl.dataset.id : 'main-cart-items';
    return [
      {
        id: 'main-cart-items',
        section: sectionId,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '.js-contents',
      },
    ];
  }

  function isShopifyDomain() {
    var host = window.location.hostname || '';
    return host.indexOf('.myshopify.com') !== -1 || host.indexOf('.shopify.com') !== -1;
  }

  function refreshCartSections() {
    window.location.href = window.location.pathname + window.location.search;
    return new Promise(function () {});
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    });
  }

  function cartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    });
  }

  function getBundleItems(cart, bundleKey) {
    var frame = null;
    var lensBase = null;
    var addons = [];
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props['_bundle_key'] !== bundleKey) return;
      var role = props['_bundle_role'];
      if (role === 'frame') frame = item;
      else if (role === 'lens_base') lensBase = item;
      else if (role === 'addon') addons.push(item);
    });
    return { frame: frame, lensBase: lensBase, addons: addons };
  }

  function removeBundleFallback(bundleKey) {
    return fetchCart().then(function (cart) {
      var group = getBundleItems(cart, bundleKey);
      var updates = {};
      [group.frame, group.lensBase].concat(group.addons).forEach(function (item) {
        if (item) updates[item.key] = 0;
      });
      if (Object.keys(updates).length === 0) return;
      return cartUpdate(updates);
    });
  }

  function removeBundleByKey(bundleKey) {
    var BundleEngine = window.OletLens && window.OletLens.BundleEngine;
    if (BundleEngine && BundleEngine.removeEntireBundle) {
      return BundleEngine.removeEntireBundle(bundleKey).catch(function (err) {
        try {
          console.error('BundleEngine.removeEntireBundle failed, falling back:', err);
        } catch (e) {}
        return removeBundleFallback(bundleKey);
      });
    }
    return removeBundleFallback(bundleKey);
  }

  function keepFrameOnly(bundleKey) {
    var BundleEngine = window.OletLens && window.OletLens.BundleEngine;
    if (BundleEngine && BundleEngine.removeBundleKeepFrame) {
      return BundleEngine.removeBundleKeepFrame(bundleKey).catch(function (err) {
        try {
          console.error('BundleEngine.removeBundleKeepFrame failed, falling back:', err);
        } catch (e) {}
        return fetchCart().then(function (cart) {
          var group = getBundleItems(cart, bundleKey);
          var updates = {};
          if (group.lensBase) updates[group.lensBase.key] = 0;
          group.addons.forEach(function (a) { updates[a.key] = 0; });
          if (group.frame) updates[group.frame.key] = 0;
          if (Object.keys(updates).length === 0) return;
          return cartUpdate(updates).then(function () {
            if (group.frame) {
              return cartAdd([{ id: group.frame.variant_id, quantity: 1 }]);
            }
          });
        });
      });
    }
    return fetchCart().then(function (cart) {
      var group = getBundleItems(cart, bundleKey);
      var updates = {};
      if (group.lensBase) updates[group.lensBase.key] = 0;
      group.addons.forEach(function (a) { updates[a.key] = 0; });
      if (group.frame) updates[group.frame.key] = 0;
      if (Object.keys(updates).length === 0) return;
      return cartUpdate(updates).then(function () {
        if (group.frame) {
          return cartAdd([{ id: group.frame.variant_id, quantity: 1 }]);
        }
      });
    });
  }

  function showBundleSpinner(btn) {
    var row = btn.closest('tr');
    if (!row) return;
    var mainCart = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCart) mainCart.classList.add('cart__items--disabled');
    var spinners = row.querySelectorAll('.loading__spinner');
    spinners.forEach(function (s) { s.classList.remove('hidden'); });
  }

  function hideBundleSpinner() {
    var mainCart = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCart) mainCart.classList.remove('cart__items--disabled');
    var spinners = document.querySelectorAll('.loading__spinner');
    spinners.forEach(function (s) { s.classList.add('hidden'); });
  }

  function lockQuantityControls() {
    var bundleRows = document.querySelectorAll('[data-bundle-key]');
    bundleRows.forEach(function (row) {
      var inputs = row.querySelectorAll('.quantity__input');
      inputs.forEach(function (input) {
        input.setAttribute('readonly', 'readonly');
        input.classList.add('pointer-events-none', 'opacity-60');
        var qtyWrapper = input.closest('.quantity');
        if (qtyWrapper) {
          var minus = qtyWrapper.querySelector('[name="minus"]');
          var plus = qtyWrapper.querySelector('[name="plus"]');
          if (minus) minus.setAttribute('disabled', 'disabled');
          if (plus) plus.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  function decodeHtmlEntities(str) {
    if (!str || typeof str !== 'string') return str;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  function attachEditListeners() {
    var buttons = document.querySelectorAll('[data-edit-bundle]');
    buttons.forEach(function (btn) {
      if (btn.dataset.oletEditBound === 'true') return;
      btn.dataset.oletEditBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var editData = {
          bundleKey: btn.getAttribute('data-edit-bundle') || '',
          usage: btn.getAttribute('data-edit-usage') || '',
          rxJson: btn.getAttribute('data-edit-rx-json') || '',
          rxMethod: btn.getAttribute('data-edit-rx-method') || '',
          rxFileUrl: btn.getAttribute('data-edit-rx-file-url') || '',
          addons: btn.getAttribute('data-edit-addons') || '',
          sunglasses: btn.getAttribute('data-edit-sunglasses') || '',
          sunglassesColor: btn.getAttribute('data-edit-sunglasses-color') || '',
          lensTitle: btn.getAttribute('data-edit-lens-title') || '',
          lensVariantId: btn.getAttribute('data-edit-lens-variant-id') || '',
          computerRxType: btn.getAttribute('data-edit-computer-rx-type') || '',
          computerLensType: btn.getAttribute('data-edit-computer-lens-type') || '',
          mainScreenDistance: btn.getAttribute('data-edit-main-screen-distance') || '',
          mainScreenDistanceUnit: btn.getAttribute('data-edit-main-screen-distance-unit') || '',
        };

        try {
          sessionStorage.setItem('olet_edit_bundle', JSON.stringify(editData));
        } catch (err) { /* ignore */ }

        var href = btn.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      });
    });
  }

  function attachRemoveListeners() {
    var frameOnlyButtons = document.querySelectorAll('[data-buy-frame-only]');
    frameOnlyButtons.forEach(function (btn) {
      if (btn.dataset.bundleListenerAttached === 'true') return;
      btn.dataset.bundleListenerAttached = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var key = btn.getAttribute('data-buy-frame-only');
        if (!key) return;

        btn.disabled = true;
        btn.textContent = 'Removing...';
        showBundleSpinner(btn);

        keepFrameOnly(key)
          .then(function () { return refreshCartSections(); })
          .then(function () { hideBundleSpinner(); })
          .catch(function (err) {
            console.error('Buy frame only error:', err);
            btn.disabled = false;
            btn.textContent = 'Buy Frame Only';
            hideBundleSpinner();
          });
      });
    });

    var removeBundleButtons = document.querySelectorAll('[data-remove-bundle]');
    removeBundleButtons.forEach(function (btn) {
      if (btn.dataset.bundleListenerAttached === 'true') return;
      btn.dataset.bundleListenerAttached = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var key = btn.getAttribute('data-remove-bundle');
        if (!key) return;

        showBundleSpinner(btn);
        btn.disabled = true;

        removeBundleByKey(key)
          .then(function () { return refreshCartSections(); })
          .then(function () { hideBundleSpinner(); })
          .catch(function (err) {
            console.error('Remove bundle error:', err);
            hideBundleSpinner();
            btn.disabled = false;
          });
      });
    });

    var removeLensBaseButtons = document.querySelectorAll('[data-remove-lens-base]');
    removeLensBaseButtons.forEach(function (btn) {
      if (btn.dataset.bundleListenerAttached === 'true') return;
      btn.dataset.bundleListenerAttached = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var key = btn.getAttribute('data-remove-lens-base');
        if (!key) return;

        btn.disabled = true;
        showBundleSpinner(btn);

        keepFrameOnly(key)
          .then(function () { return refreshCartSections(); })
          .then(function () { hideBundleSpinner(); })
          .catch(function (err) {
            console.error('Remove lens base error:', err);
            btn.disabled = false;
            hideBundleSpinner();
          });
      });
    });

    var removeAddonButtons = document.querySelectorAll('[data-remove-addon]');
    removeAddonButtons.forEach(function (btn) {
      if (btn.dataset.bundleListenerAttached === 'true') return;
      btn.dataset.bundleListenerAttached = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var lineKey = btn.getAttribute('data-remove-addon');
        if (!lineKey) return;

        btn.disabled = true;
        showBundleSpinner(btn);

        var updates = {};
        updates[lineKey] = 0;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart update failed');
            return refreshCartSections();
          })
          .then(function () { hideBundleSpinner(); })
          .catch(function (err) {
            console.error('Remove addon error:', err);
            btn.disabled = false;
            hideBundleSpinner();
          });
      });
    });
  }

  function attachViewRxListeners() {
    var buttons = document.querySelectorAll('.bundle-view-rx-btn');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rxJsonStr = decodeHtmlEntities(btn.getAttribute('data-rx-json'));
        var rxFileUrl = btn.getAttribute('data-rx-file-url') || '';
        var usageType = btn.getAttribute('data-usage-type') || '';

        if (!rxJsonStr) return;

        var rx;
        try {
          rx = JSON.parse(rxJsonStr);
        } catch (e) {
          return;
        }

        showBundleRxModal(rx, rxFileUrl, usageType);
      });
    });
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val != null ? String(val) : '-';
  }

  function showBundleRxModal(rx, rxFileUrl, usageType) {
    var modal = document.getElementById('prescription-modal');
    if (!modal) return;

    setText('modal-od-sph', rx.od ? Number(rx.od.sph || 0).toFixed(2) : '-');
    setText('modal-od-cyl', rx.od ? Number(rx.od.cyl || 0).toFixed(2) : '-');
    setText('modal-od-axis', rx.od && rx.od.axis ? Number(rx.od.axis) : '-');
    setText('modal-od-add', rx.od && rx.od.add && rx.od.add !== 'n/a' ? rx.od.add : 'N/A');
    setText('modal-os-sph', rx.os ? Number(rx.os.sph || 0).toFixed(2) : '-');
    setText('modal-os-cyl', rx.os ? Number(rx.os.cyl || 0).toFixed(2) : '-');
    setText('modal-os-axis', rx.os && rx.os.axis ? Number(rx.os.axis) : '-');
    setText('modal-os-add', rx.os && rx.os.add && rx.os.add !== 'n/a' ? rx.os.add : 'N/A');

    if (rx.pd) {
      if (rx.pd.combined) {
        setText('modal-od-pd', rx.pd.combined);
        setText('modal-os-pd', rx.pd.combined);
      } else {
        setText('modal-od-pd', rx.pd.left || rx.pd.right || '-');
        setText('modal-os-pd', rx.pd.right || rx.pd.left || '-');
      }
    } else {
      setText('modal-od-pd', '-');
      setText('modal-os-pd', '-');
    }

    var prismContainer = document.getElementById('od-prism-container');
    if (prismContainer) {
      if (rx.hasPrism && rx.prism) {
        prismContainer.classList.remove('hidden');
        var p = rx.prism;
        setText('modal-od-vertical-prism', p.od ? p.od.vertical : '-');
        setText('modal-od-base-direction', p.od ? p.od.vertical_dir : '-');
        setText('modal-od-horizontal-prism', p.od ? p.od.horizontal : '-');
        setText('modal-od-other-base-direction', p.od ? p.od.horizontal_dir : '-');
        setText('modal-os-vertical-prism', p.os ? p.os.vertical : '-');
        setText('modal-os-base-direction', p.os ? p.os.vertical_dir : '-');
        setText('modal-os-horizontal-prism', p.os ? p.os.horizontal : '-');
        setText('modal-os-other-base-direction', p.os ? p.os.horizontal_dir : '-');
      } else {
        prismContainer.classList.add('hidden');
      }
    }

    var personContainer = document.getElementById('modal-person-container');
    if (personContainer) {
      if (rx.person_name) {
        personContainer.classList.remove('hidden');
        setText('modal-person-name', rx.person_name);
      } else {
        personContainer.classList.add('hidden');
      }
    }

    var commentsContainer = document.getElementById('modal-comments-container');
    if (commentsContainer) {
      if (rx.comments && rx.comments.trim()) {
        commentsContainer.classList.remove('hidden');
        setText('modal-comments', rx.comments);
      } else {
        commentsContainer.classList.add('hidden');
      }
    }

    var lensType = usageType ? usageType.replace(/_/g, ' ') : '-';
    setText('modal-lens-type', lensType);

    var strengthContainer = document.getElementById('modal-strength-container');
    if (strengthContainer) {
      if (rx.reading_strength) {
        strengthContainer.classList.remove('hidden');
        setText('modal-strength', rx.reading_strength);
      } else {
        strengthContainer.classList.add('hidden');
      }
    }

    var packageContainer = document.getElementById('modal-package-container');
    if (packageContainer) packageContainer.classList.add('hidden');

    var sunglassesContainer = document.getElementById('modal-sunglasses-container');
    if (sunglassesContainer) sunglassesContainer.classList.add('hidden');

    var addonsContainer = document.getElementById('modal-addons-container');
    if (addonsContainer) addonsContainer.classList.add('hidden');

    var fileContainer = document.getElementById('modal-prescription-file-container');
    var imageElement = document.getElementById('modal-prescription-image');
    var pdfContainer = document.getElementById('modal-prescription-pdf');
    var pdfOpenLink = document.getElementById('modal-prescription-pdf-open-link');

    if (fileContainer) {
      if (rxFileUrl && rxFileUrl.trim()) {
        var lowerUrl = rxFileUrl.toLowerCase();
        var isPdf =
          lowerUrl.endsWith('.pdf') ||
          lowerUrl.indexOf('.pdf?') !== -1 ||
          lowerUrl.indexOf('data:application/pdf') === 0;
        var isImage =
          lowerUrl.indexOf('data:image/') === 0 ||
          /\.(jpg|jpeg|png|gif|bmp|webp)(\?|$)/i.test(rxFileUrl);

        fileContainer.classList.remove('hidden');

        if (isPdf && pdfContainer) {
          if (imageElement) imageElement.classList.add('hidden');
          pdfContainer.classList.remove('hidden');
          if (pdfOpenLink) {
            pdfOpenLink.href = rxFileUrl;
            pdfOpenLink.classList.add('hidden');
          }
          if (window.renderCartModalPDF) {
            window.renderCartModalPDF(rxFileUrl);
          }
        } else if (isImage && imageElement) {
          if (pdfContainer) pdfContainer.classList.add('hidden');
          imageElement.classList.remove('hidden');
          imageElement.src = rxFileUrl;
        } else {
          fileContainer.classList.add('hidden');
        }
      } else {
        fileContainer.classList.add('hidden');
      }
    }

    var prescriptionTable = modal.querySelector('.table_component');
    if (prescriptionTable) {
      if (usageType === 'reading' || usageType === 'non-prescription' || rx.non_prescription) {
        prescriptionTable.style.display = 'none';
      } else {
        prescriptionTable.style.display = '';
      }
    }

    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function reattachBundleListeners() {
    lockQuantityControls();
    attachEditListeners();
    attachRemoveListeners();
    attachViewRxListeners();
  }

  function init() {
    if (!document.getElementById('cart-items-body')) {
      return;
    }

    reattachBundleListeners();

    var BundleEngine = window.OletLens && window.OletLens.BundleEngine;
    if (BundleEngine && BundleEngine.runAutoClean) {
      BundleEngine.runAutoClean()
        .then(function (result) {
          if (result && result.corrected) {
            showToast('We updated your cart to keep lens selections consistent.', 'info');
            return refreshCartSections();
          }
        })
        .catch(function (err) {
          console.error('AutoClean error:', err);
        });
    }
  }

  window.OletLens.BundleUI = {
    init: init,
    showToast: showToast,
    lockQuantityControls: lockQuantityControls,
    reattachBundleListeners: reattachBundleListeners,
    attachEditListeners: attachEditListeners,
    attachRemoveListeners: attachRemoveListeners,
    attachViewRxListeners: attachViewRxListeners,
    refreshCartSections: refreshCartSections,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
